export enum PublicProfileBlockTypeEnum {
  HTML = "HTML",
  IMAGE = "IMAGE",
}
